import { fetchDqxQuarantineResults, fetchDqxSummary } from "@/services/api";
import { computeDqxRowLevelSummary } from "@/services/dqxSummaryMetrics";

export interface PipelineDqxRowSummary {
  rowsPassing: number;
  rowsWithIssues: number;
  totalRowsChecked: number;
}

export function computePipelineDqxRowSummary(
  quarantineTable: Record<string, unknown>[],
  rowCount: number | null | undefined
): PipelineDqxRowSummary {
  const totalRowsChecked =
    rowCount != null && rowCount > 0 ? rowCount : Math.max(quarantineTable.length, 0);
  const summary = computeDqxRowLevelSummary(quarantineTable, totalRowsChecked, null);
  return {
    rowsPassing: summary.rowsPassingAllChecks,
    rowsWithIssues: summary.rowsWithAtLeastOneFailure,
    totalRowsChecked: summary.totalRowsChecked,
  };
}

export async function fetchPipelineDqxRowSummary(
  jobId: string,
  rowCount: number | null | undefined
): Promise<PipelineDqxRowSummary> {
  try {
    const summary = await fetchDqxSummary(jobId);
    const rowsWithIssues = summary.failingRowCount;
    const totalRowsChecked =
      rowCount != null && rowCount > 0 ? rowCount : Math.max(rowsWithIssues, 0);
    return {
      rowsPassing: Math.max(0, totalRowsChecked - rowsWithIssues),
      rowsWithIssues,
      totalRowsChecked,
    };
  } catch {
    const quarantine = await fetchDqxQuarantineResults(jobId);
    return computePipelineDqxRowSummary(quarantine.quarantine_table, rowCount);
  }
}
